import { CheckinTarget, parseCheckinUrl } from './scan-event/parse-checkin-url';

/**
 * Decide whether a captured deep link should open an event in THIS build, and to
 * which event. Reuses parseCheckinUrl (the same host-agnostic, digits-only-pin
 * contract the QR scanner uses), then requires the link's host to match this
 * build's clientUrl — so a production app never silently opens a staging link
 * (or vice-versa) and POSTs to the wrong API. Returns null to ignore the link.
 *
 * Kept free of Capacitor so it is unit-testable on its own (see the .spec).
 */
export function resolveDeepLinkTarget(
  raw: string,
  clientUrl: string
): CheckinTarget | null {
  const target = parseCheckinUrl(raw);
  if (!target) {
    return null;
  }
  try {
    if (new URL(raw).host !== new URL(clientUrl).host) {
      return null;
    }
  } catch {
    return null;
  }
  return target;
}
